import React from 'react';
import { BsSearch, BsArrowDown, BsChevronDown, BsGrid, BsViewStacked } from 'react-icons/bs';
import colors from '../../assets/styles/colors';
import {
  FilterContainer,
  FilterColumn,
  FilterInputSearch,
  FilterOrderBy,
  FilterOrderBySpan,
  FilterOrderByOption,
  FilterShowContent,
  FilterShowOptionSpan,
  FilterShowOptionContent,
  FilterShowOptionSelectOption,
  FilterShowOptionSelect,
  FilterShowOptionSelected,
  FilterDisplay,
  FilterDisplayIcon
} from './styles';

const Filter = ({ statusDescription, orderByCurrent, showBy, showByExpand, gridByRow, setOrderByCurrent, setShowByExpand, setShowBy, setSearch, setTimeOutFade }) => {
  return (
    <FilterContainer id="filter">
      <FilterColumn>
        <BsSearch size={18} color={colors.bgSecondary} id="search-icon" />
        <FilterInputSearch placeholder="Nombre, apellido, CC o CE" onChange={e => setSearch(e.target.value)} id="search-field" />
      </FilterColumn>
      <FilterColumn>
        <FilterOrderBy>
          <FilterOrderBySpan>Ordenar por</FilterOrderBySpan>
          <FilterOrderByOption current={orderByCurrent} onClick={() => setOrderByCurrent(!orderByCurrent)} id="order-by-current">
            Fecha
            <BsArrowDown color={colors.bgSecondary} size={20} id="arrow-down-icon" />
          </FilterOrderByOption>
        </FilterOrderBy>
      </FilterColumn>
      <FilterColumn>
        <FilterShowContent>
          <FilterShowOptionSpan>Visualizar</FilterShowOptionSpan>
          <FilterShowOptionSelect onClick={() => setShowByExpand(!showByExpand)} tabIndex={0} onBlur={() => setShowByExpand(false)} id="show-by">
            <FilterShowOptionSelected>{showBy}</FilterShowOptionSelected>
            <BsChevronDown id="chevron-downicon" />
            <FilterShowOptionContent open={showByExpand} id="select-category">
              <FilterShowOptionSelectOption active={showBy === 'Todos' && true} onClick={() => setShowBy('Todos')}>Todos</FilterShowOptionSelectOption>
              {statusDescription.map((item, key) => item && (
                <FilterShowOptionSelectOption
                  id={`category${key}`}
                  key={key}
                  active={item.label === showBy && true}
                  onClick={() => setShowBy(item.label)}>
                  {item.label}
                </FilterShowOptionSelectOption>)
              )}
            </FilterShowOptionContent>
          </FilterShowOptionSelect>
        </FilterShowContent>
        <FilterDisplay>
          <FilterDisplayIcon row={!gridByRow} onClick={() => setTimeOutFade(false)} id="filter-by-grid">
            <BsGrid size={14} id="grid-icon" />
          </FilterDisplayIcon>
          <FilterDisplayIcon row={gridByRow} onClick={() => setTimeOutFade(true)} id="filter-by-col">
            <BsViewStacked size={14} id="view-stacked-icon" />
          </FilterDisplayIcon>
        </FilterDisplay>
      </FilterColumn>
    </FilterContainer>
  )
}

export default Filter;
